var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigitalDisplay3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 166.89 485.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#4588aa;stroke-miterlimit:10;}.cls-1{stroke-width:5px;}.cls-2{stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "48.89 2.5 106.89 2.5 164.39 60 164.39 142.51 108.89 198.01 108.89 306.5 127.39 325 127.39 410.5 88.64 449.25 35.89 449.25 1.77 483.38"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 64.89,
    y1: 16.5,
    x2: 48.89,
    y2: 32.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 74.89,
    y1: 16.5,
    x2: 58.89,
    y2: 32.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 84.89,
    y1: 16.5,
    x2: 68.89,
    y2: 32.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 94.89,
    y1: 16.5,
    x2: 78.89,
    y2: 32.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalDisplay3);
export default __webpack_public_path__ + "static/media/digitalDisplay3.23796d88edecdf8ac9054728cee79a3d.svg";
export { ForwardRef as ReactComponent };